import { Text } from 'components/blueprint';

import {
  acceptCoBrowseOffering,
  declineCoBrowseOffering,
} from 'genesys/genesys';
import { useSafeLabel } from 'hooks';
import {
  useCoBrowseActioned,
  useSetCoBrowseActioned,
} from 'state/coBrowseActioned';

import messages from './messages';
import { ActionLabelPill, ActionPillWrapper } from '../ActionPillWrapper';

export const CoBrowseActions = ({ coBrowse, isFeedbackEnable }) => {
  const coBrowseActioned = useCoBrowseActioned();
  const safelabel = useSafeLabel();
  const setCoBrowseActioned = useSetCoBrowseActioned();
  const isCoBrowseActionDisable = !(isFeedbackEnable && !coBrowseActioned);

  const handleCoBrowseAccept = (event) => {
    event.preventDefault();

    if (isCoBrowseActionDisable) {
      return;
    }

    setCoBrowseActioned(true);
    acceptCoBrowseOffering({ ...coBrowse });
  };

  const handleCoBrowseDecline = (event) => {
    event.preventDefault();

    if (isCoBrowseActionDisable) {
      return;
    }

    setCoBrowseActioned(true);
    declineCoBrowseOffering({ ...coBrowse });
  };

  return (
    <ActionPillWrapper>
      <ActionLabelPill
        tabIndex="0"
        disabled={isCoBrowseActionDisable}
        onClick={handleCoBrowseAccept}
      >
        <Text>{safelabel(messages.accept)}</Text>
      </ActionLabelPill>
      <ActionLabelPill
        tabIndex="0"
        disabled={isCoBrowseActionDisable}
        onClick={handleCoBrowseDecline}
      >
        <Text>{safelabel(messages.decline)}</Text>
      </ActionLabelPill>
    </ActionPillWrapper>
  );
};
